/**
 * Admin Auto Redirect Component
 * Automatically redirects admin users to the admin dashboard after login
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function AdminAutoRedirect() {
  const { isAdmin, loading, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if still loading or no user
    if (loading || !user) return;

    // Don't redirect if already on admin page
    if (location.pathname.startsWith('/admin')) return;

    // Don't redirect if on auth pages (let them complete login first)
    if (location.pathname === '/breeder-auth') return;

    // Redirect admin users to admin dashboard ONLY if they are on the login page or explicitly landing
    if (isAdmin && (location.pathname === '/auth' || location.pathname === '/')) {
      console.log('Admin user detected on auth/home, redirecting to admin dashboard');
      navigate('/admin', { replace: true });
    }
  }, [isAdmin, loading, user, location.pathname, navigate]);

  return null; // This component doesn't render anything
}
